/* dsr-modal.js — popup info prodotto (riutilizzabile su tutte le PDP gofor360) */
(function () {
  "use strict";
  if (window.__dsrModalReady) return;
  window.__dsrModalReady = true;

  var css = ""
    + ".dsrm-overlay{position:fixed;inset:0;background:rgba(15,32,26,.55);backdrop-filter:blur(3px);display:flex;align-items:center;justify-content:center;padding:20px;z-index:99999;opacity:0;visibility:hidden;transition:opacity .25s,visibility .25s;}"
    + ".dsrm-overlay.open{opacity:1;visibility:visible;}"
    + ".dsrm-box{background:#fff;border-radius:22px;max-width:440px;width:100%;max-height:90vh;overflow-x:hidden;overflow-y:auto;box-shadow:0 30px 80px rgba(0,0,0,.35);transform:translateY(16px) scale(.98);transition:transform .28s cubic-bezier(.34,1.56,.64,1);position:relative;font-family:'Segoe UI',system-ui,sans-serif;}"
    + ".dsrm-overlay.open .dsrm-box{transform:none;}"
    + ".dsrm-close{position:absolute;top:12px;right:12px;width:34px;height:34px;border-radius:50%;border:none;background:rgba(255,255,255,.9);color:#16352A;font-size:22px;line-height:1;cursor:pointer;z-index:2;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 8px rgba(0,0,0,.15);}"
    + ".dsrm-close:hover{background:#fff;}"
    + ".dsrm-img{width:100%;aspect-ratio:16/11;background:#F4ECDD;overflow:hidden;}"
    + ".dsrm-img img{width:100%;height:100%;object-fit:cover;display:block;}"
    + ".dsrm-body{padding:22px 26px 26px;}"
    + ".dsrm-tag{display:inline-block;font-size:10.5px;font-weight:800;letter-spacing:1.3px;text-transform:uppercase;color:#176173;background:rgba(31,122,140,.1);border:1px solid rgba(31,122,140,.25);padding:4px 11px;border-radius:20px;margin-bottom:12px;}"
    + ".dsrm-title{font-family:Georgia,serif;font-size:25px;color:#16352A;line-height:1.2;margin:0 0 8px;font-weight:700;}"
    + ".dsrm-price{display:flex;align-items:baseline;gap:9px;margin-bottom:12px;}"
    + ".dsrm-price .now{font-family:Georgia,serif;font-size:24px;font-weight:800;color:#16352A;}"
    + ".dsrm-price .old{font-size:15px;color:#aa9;text-decoration:line-through;}"
    + ".dsrm-desc{font-size:14.5px;color:#4a5650;line-height:1.6;margin:0 0 16px;}"
    + ".dsrm-note2{display:flex;align-items:center;gap:8px;background:rgba(61,139,94,.1);border:1px solid rgba(61,139,94,.32);color:#2f6b46;font-weight:700;font-size:13.5px;line-height:1.4;padding:11px 14px;border-radius:11px;margin:0 0 18px;}"
    + ".dsrm-cta{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;background:linear-gradient(135deg,#1F7A8C,#16352A);color:#fff;border:none;padding:15px;border-radius:13px;font-weight:800;font-size:15px;text-transform:uppercase;letter-spacing:.4px;cursor:pointer;text-decoration:none;transition:transform .15s;}"
    + ".dsrm-cta:hover{transform:translateY(-2px);}"
    + ".dsrm-note{text-align:center;font-size:12px;color:#9aa39e;margin-top:11px;}";
  var st = document.createElement("style"); st.textContent = css; document.head.appendChild(st);

  var ov = document.createElement("div");
  ov.className = "dsrm-overlay";
  ov.innerHTML =
    '<div class="dsrm-box" role="dialog" aria-modal="true">' +
    '<button class="dsrm-close" aria-label="Chiudi">&times;</button>' +
    '<div class="dsrm-img"><img id="dsrmImg" alt=""></div>' +
    '<div class="dsrm-body">' +
    '<span class="dsrm-tag" id="dsrmTag"></span>' +
    '<h3 class="dsrm-title" id="dsrmTitle"></h3>' +
    '<div class="dsrm-price"><span class="now" id="dsrmPrice"></span><span class="old" id="dsrmOld"></span></div>' +
    '<p class="dsrm-desc" id="dsrmDesc"></p>' +
    '<div class="dsrm-note2" id="dsrmNote" style="display:none"></div>' +
    '<a class="dsrm-cta" id="dsrmCta" href="#">Vai al prodotto &rarr;</a>' +
    '<div class="dsrm-note">Si apre nella scheda prodotto</div>' +
    '</div></div>';
  document.body.appendChild(ov);

  function close() { ov.classList.remove("open"); document.body.style.overflow = ""; }
  function open() { ov.classList.add("open"); document.body.style.overflow = "hidden"; }
  ov.addEventListener("click", function (e) { if (e.target === ov) close(); });
  ov.querySelector(".dsrm-close").addEventListener("click", close);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });

  window.dsrInfo = function (el) {
    var d = el.dataset || {};
    var img = document.getElementById("dsrmImg");
    img.src = d.infoImg || ""; img.alt = d.infoTitle || "";
    var tag = document.getElementById("dsrmTag");
    tag.textContent = d.infoTag || ""; tag.style.display = d.infoTag ? "" : "none";
    document.getElementById("dsrmTitle").textContent = d.infoTitle || "";
    document.getElementById("dsrmPrice").textContent = d.infoPrice || "";
    var old = document.getElementById("dsrmOld");
    old.textContent = d.infoOld || ""; old.style.display = d.infoOld ? "" : "none";
    document.getElementById("dsrmDesc").textContent = d.infoDesc || "";
    var note = document.getElementById("dsrmNote");
    if (d.infoNote) { note.innerHTML = d.infoNote; note.style.display = ""; } else { note.style.display = "none"; }
    var cta = document.getElementById("dsrmCta");
    cta.setAttribute("href", d.infoHref || "#");
    cta.firstChild ? (cta.innerHTML = (d.infoCta || "Vai al prodotto") + " &rarr;") : null;
    open();
    return false;
  };
})();
